export default {
  brand: {
    name: 'USFansLink',
    tagline: 'Centrum zasobów arkusza',
  },
  nav: {
    home: 'Strona główna',
    shoppingGuide: 'Poradnik zakupów',
    articles: 'Artykuły',
    qc: 'Poradnik QC',
    shipping: 'Wysyłka',
    faq: 'FAQ',
    browse: 'Przeglądaj kategorie',
  },
  buttons: {
    buyNow: 'Kup teraz',
    explore: 'Poznaj arkusz USFans',
    browseGuides: 'Przeglądaj poradniki',
    readMore: 'Przeczytaj poradnik',
    backHome: 'Wróć do strony głównej',
    viewAll: 'Zobacz wszystkie kategorie',
    continue: 'Przejdź do głównej strony',
  },
  footer: {
    about: 'USFansLink.site to niezależne źródło informacji o arkuszu USFans. Pomagamy kupującym znaleźć linki do produktów, informacje QC, poradniki wysyłki i bezpieczne wskazówki zakupowe.',
    quickLinks: 'Szybkie linki',
    categories: 'Kategorie',
    resources: 'Zasoby',
    language: 'Język',
    disclaimer: 'Zastrzeżenie: linki zewnętrzne, produkty, ceny, informacje o wysyłce i promocje mogą ulec zmianie. Zawsze weryfikuj aktualne informacje przed zakupem lub płatnością.',
    copyright: 'Wszelkie prawa zastrzeżone.',
  },
};